export default "__VITE_ASSET__AC61BAkU__"